import textToAudio from './src'
textToAudio.install = Vue => {
  Vue.component(textToAudio.name, textToAudio)
}
export default textToAudio


// WEBPACK FOOTER //
// ./packages/text-to-audio/index.js